export default (tag, props = {}) => {
    const node = document.createElement(tag)
    Object.keys(props).forEach(key => node[key] = props[key])

    return node
}
